function digitsOf(input) {
  return input.toString().split('').map((c) => parseInt(c, 10));
}

function modifiedDouble(input) {
  const doubled = input * 2;
  return doubled > 9 ? doubled - 9 : doubled;
}

export default function luhnCheck(value) {
  const digits = digitsOf(value);

  const sum = digits.reverse().reduce((current, next, index) => {
    const addend = index % 2 === 1 ? modifiedDouble(next) : next;
    return current + addend;
  });

  return sum % 10 === 0;
}



/** WEBPACK FOOTER **
 ** ./modules/credit-card/luhnCheck.js
 **/